import { useEffect, useState } from "react";
import { STORAGE_KEYS } from "src/constants/common";
import storage from "src/helpers/storage";

const useThemeColors = () => {
  const [colors, setColors] = useState<any>({});

  useEffect(() => {
    const themeColors = storage.getItem(STORAGE_KEYS.THEME_COLORS);
    if (themeColors) {
      setColors(JSON.parse(themeColors));
    }
  }, []);

  return colors;
};

export default useThemeColors;
